import styled, { css } from 'styled-components';

export const ListStyled = styled.ul(
    ({ theme }) => css`
        padding: 0 ${theme.gap.default};
        margin: 0 -${theme.gap.default} 24px;
        position: relative;

        @media ${theme.mediaQueries.queryVl} {
            margin: 0;
            padding: 10px 30px;

            border: 5px solid ${theme.color.grayLight};
            border-radius: ${theme.radius.medium};
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    `,
);
